module.exports = __webpack_public_path__ + "static/media/whyShootsta.de45881c.vtt";